<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>
      <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
      <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
  
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("hs_code") }}</h4>
                    <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="createData()">
                      <i class="link-icon mdi mdi-plus"></i>
                      {{ $t("createNew") }}
                    </button>
  
                    <!-- <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadData()">
                      <i class="link-icon mdi mdi-download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>

                    <button v-if="permision_role.method_read" class="btn btn-dark float-end btn-xs"
                      style="margin-right: 5px" @click="massUpload()" type="button">
                      <i class="link-icon mdi mdi-upload"></i>
                      Upload
                    </button> -->
  
                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="list-exim-ceisa-system-code" ref="list-exim-ceisa-system-code"
                      mode="remote" @on-page-change="onPageChange"
                      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" 
                     
                      @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                      :isLoading.sync="isLoading" :pagination-options="{
                       
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }" :rows="rows" :columns="columns">
   
                        <template slot="table-row" slot-scope="props">          
                            <span v-if="props.column.field == 'actions'">
                                <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                                    detailData(props.index, props.row)
                                    ">
                                    <i class="mdi mdi-eye" style="font-size:16px;color:blue;"></i>

                                </a>
                            </span>

                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                            
                    </template>

                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
          
          <!--begin::modal-->
          <modal name="createNewHsCode" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                  role="dialog">
                  <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
      
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("create") +" Hs Code" }}  </h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
      
                      <form class="forms-sample" @submit.prevent="submitHsCode()" method="POST">
                      <div class="modal-body">

                        <div class="mb-3">

                            <label for="files" class="form-label">{{ this.$t("hs_code") }}:</label>

                            <input type="text" class="form-control" v-model="inputHs">

                            <div v-if="errors.hs_code">
                                <div v-for="error in errors.hs_code" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                                </div>
                            </div>

                        </div>

                        <div class="mb-3 table-responsive" v-if="rowResponse.length > 0">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th>HS Code</th>
                                  <th>Uraian</th>
                                  <th>Message</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="row in rowResponse " :key="row.hs_code">
                                  <td>{{ row.hs_code }}</td>
                                  <td>{{ row.uraian }}</td>
                                  <td>{{ row.message }}</td>
                                </tr>
                              </tbody>

                            </table>
                        </div>

                      
                      </div>
      
      
                      <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                        <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
                      </div>
                      </form>
      
      
                    </div>
                  </div>
                </div>
              </modal>
   
  
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
    
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
    name: "CeisaSystemCodeIndex",
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
        return {
            inputHs:"",
          
            digit: {
                decimal: ',',
                thousands: '.',
                prefix: ' ',
                suffix: '',
                precision: 5,
                masked: false
            },
            filterOrderType:[],
            forms: {},
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            idAsnHeaders:[],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            BAS_SKU_IDs: [],
            detailDivisi: [],
            totalRecords: 0,
            activeFlag : false,
            shelfLifeFlag : false,
            kitFlag : false,
            freePickGift : false,
            serverParams: {
            columnFilters: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            per_page: 10,
            },
       
            columns: [
    
                {
                    label: "HS Code ID",
                    field: "master_hs_code_id",
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "HS Code Format",
                    field: "hs_code_format",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "Hs Code",
                    field: "hs_code",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
    
                {
                    label: "Uraian",
                    field: "uraian",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
                {
                    label: "Action",
                    field: "actions",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
         
            ],
            rows: [],
            rowsSelection: [],
            rowResponse:[],
            filemassUploadSo: '',
            errorsDataSoUpload: false,
      };
    },
    watch: {},
    methods: {
    
        removeModals() {
            this.$modal.hide('createNewHsCode');
            
        },
  
        submitHsCode() {
                this.isLoading = true;
        
                let formData = new FormData();
                formData.append("hs_code", this.inputHs);
        
                const baseURI = this.$settings.endPointCeisa + "v1/system-code/hs-code/add";
                this.$http.post(baseURI, formData).then((response) => {
                  this.loading();
                  this.errors = [];
                  this.rowResponse = response.data.datas;
                }).catch((error) => {
                    this.loading();
            
            
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
            
                    } else {
            
                        if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                        }
            
                    }
                });
        
            },
        
            
        downloadData() {
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";
            this.isLoading = true;
            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&system_code_id=${this.serverParams.columnFilters.system_code_id}&type=${this.serverParams.columnFilters.type}&code=${this.serverParams.columnFilters.code}&name=${this.serverParams.columnFilters.name}&status=${this.serverParams.columnFilters.status}&download=download`,
    
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
                
            }).catch((error) => {

                this.isLoading = false;
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
            });

        },
  
        createData() {
          this.$modal.show('createNewHsCode');
        },
  
      
  
        detailData(index, row) {
    
            var params = this.$onRandom(row.master_hs_code_id);
            window.location.href = "/exim/ceisa/hs-code/detail/" + params;

        },
  
        loadItems() {

            const baseURI = this.$settings.endPointCeisa + "v1/system-code/hs-code";

            this.isLoading = true;
            
            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&master_hs_code_id=${this.serverParams.columnFilters.master_hs_code_id}&hs_code_format=${this.serverParams.columnFilters.hs_code_format}&hs_code=${this.serverParams.columnFilters.hs_code}&uraian=${this.serverParams.columnFilters.uraian}`,
                { timeout: 10000 })
                .then((response) => {

                    this.isLoading      = false;
                    this.rows           = response.data.datas.data;
                    this.totalRecords   = response.data.datas.total;

                 }).catch((error) => {
                    
                    this.isLoading      = false;
    
                if (error.code == "ECONNABORTED") {
                    
                    this.error(this.$t("check_internet_connection_txt"));
    
                }else{
    
                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                        this.logout();
                        } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                        } else {
                        this.$router.push('/page-not-found');
                        }
                    }
    
                }
            });
        },

  
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
  
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
  
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "success",
            title: kata,
            });
        },
  
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },
  
        fade(sType) {
            this.isLoading = sType;
        },
  
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },
  
        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
            if (permision.permission.controller == 'CeisaSystemCodeController') {
                rolePermision = permision;
            }
            });
    
            if (!rolePermision.method_read) {
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
    
        },
  
  
        logout() {
    
            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
    
            console.log(response);
    
            });
    
            this.$logoutUser();
            window.location.href = '/';
        },

    },
    events: {},
    created: function () { },
    
    mounted() {
        this.fetchIt();
        this.loading();
    },
};
</script>
<style scoped>
    .blur-content {
    filter: blur(5px);
    }
</style>